export default __webpack_public_path__ + "static/media/background_about_us_desktop.9eb40e03.png";